import axios from "../../utils/axios";

export const getVideos = async (tags, search, author, page) => {
    let queryString = "";

    if(page) {
        queryString += `_page=${page}&_limit=${2}`;
    }

    if(author) {
        queryString += `&author_like=${author}&`;
    }
    if (tags?.length > 0) {
        queryString += tags.map((tag) => `&tags_like=${tag}`);
    }

    if (search !== "") {
        queryString += `&q=${search}`;
    }

    console.log("query ", queryString);

    const response = await axios.get(`/videos/?${queryString}`);

    return  { data: response.data, totalLength: response.headers["x-total-count"] };
};
